import GridView from "src/SharedComponents/GridView/GridView";
import { useState } from "react";
import LogoText from "../../SharedComponents/LogoText/LogoText";
import { useTranslation } from "react-i18next";
import PartnerInfo from "./PartnerInfo/PartnerInfo";
import EditPartenerData from "./EditPartnerData/EditPartnerData";
import { usePartnerInfo } from "src/Utils/Hooks/usePartnerInfoContext";
import PartnerSupportInfo from "./PartnerSupportInfo";
import { MailIcon, PhoneIcon, MapPinIcon } from "src/SharedComponents/Icons/Icons";

const Contact: React.FC = () => {
    const { distributorDetails } = usePartnerInfo();
    const [enableEditPartnerData, setEnableEditPartnerData] = useState<boolean>(false);
    const { t } = useTranslation();

    return (
        <>
            {distributorDetails &&
                <GridView title={t("ContactInfo")}>
                    <div className="d-flex flex-column">
                       {
                       !enableEditPartnerData ?
                        (<><PartnerInfo
                                    partnerDetails={distributorDetails}
                                    onEditPartnerClick={() => setEnableEditPartnerData(true)} />
                                    <PartnerSupportInfo partnerDetails={ distributorDetails } />
                        </>
                    )
                       :
                       <EditPartenerData partnerDetails={distributorDetails} onClose={() => setEnableEditPartnerData(false)}/>
                    }
                    </div>
                </GridView>
            }
            <GridView title="Hexagon Aura Reality AG">
                <div className="d-flex flex-column">
                    <LogoText logoElement={<MailIcon />} text='office@aurareality.com' />
                    <LogoText logoElement={<PhoneIcon />} text='+41 71 727 41 41' />
                    <LogoText logoElement={<MapPinIcon />} text='Heinrich-Wild-Strasse 201, 9435 Heerbrugg, Switzerland' />
                </div>
            </GridView>
        </>
    )
}
export default Contact;
